export default {
	id: 'SIMPLE_WORKBOOK_BUNDLE_26',
	providers: {
		paltaMap: {
			USD: 'simple_workbook_bundle_26_usd',
			EUR: 'simple_workbook_bundle_26_eur',
			TRY: 'simple_workbook_bundle_1599_try',
			AUD: 'simple_workbook_bundle_29_aud',
			GBP: 'simple_workbook_bundle_26_gbp',
			CAD: 'simple_workbook_bundle_29_cad',
			BRL: 'simple_workbook_bundle_89_brl',
			MXN: 'simple_workbook_bundle_399_mxn',
			DKK: 'simple_workbook_bundle_229_dkk',
			NOK: 'simple_workbook_bundle_249_nok',
			SEK: 'simple_workbook_bundle_279_sek',
		},
		primer: 'prd_yZsaO1GHthm5',
	},
	otp: {
		priceMap: {
			USD: 26,
			EUR: 26,
			TRY: 1599,
			AUD: 29,
			GBP: 26,
			CAD: 29,
			BRL: 89,
			MXN: 399,
			DKK: 229,
			NOK: 249,
			SEK: 279,
		},
	},
}
